import identity from 'lodash/identity'
import pickBy from 'lodash/pickBy'

import type { HTMLMeta } from '@app/constants/StoreTypes'

import { createSelector } from '@app/utils/createSelector'

import { createReduxSlice } from '@app/store/redux_slice'

import sharingUrl from '@app/assets/sharing/kidsout.jpg'

export const DEFAULT_META_STATE: HTMLMeta = {
  title: 'Kidsout. Лучшие бебиситтеры для ваших детей',
  description: 'Отдохните от детей — найдите им проверенного бебиситтера и сходите по своим делам',
  image: sharingUrl,
  keywords: [
    'kidsout',
    'кидзаут',
    'кидсаут',
    'няня на час',
    'бебиситтер',
    'ситтер',
    'няня',
    'сиделка',
    'присмотр за детьми',
    'онлайн-ситтер',
    'онлайн-бебиситтер',
    'онлайн-присмотр за детьми',
    'онлайн-няня',
    'онлайн-сиделка',
  ].join(', '),
  canonical: undefined,
}

const metaSlice = createReduxSlice<HTMLMeta>('meta')

export const metaSelector = createSelector([metaSlice.selector], meta => meta ?? DEFAULT_META_STATE)

/** Back to the defaults, so a route that sets no meta of its own cannot inherit the previous one's. */
export const resetMetaSlice = () => metaSlice.set(DEFAULT_META_STATE)

export const setMetaSlice = (meta: Partial<HTMLMeta>) =>
  metaSlice.update(state => ({ ...DEFAULT_META_STATE, ...pickBy(meta, identity), canonical: meta.canonical || state?.canonical }))

export const updateMetaSlice = (meta: Partial<HTMLMeta>) => metaSlice.update(state => ({ ...(state ?? DEFAULT_META_STATE), ...pickBy(meta, identity) }))
